/*
 * *****************************************************************************
 * File: routes.js (/src/routes.js) | frontend
 * Written by Andrea Corsini <andrea@rs1.it>
 * =============================================================
 * Created on Tuesday, 23rd March 2021 2:04:00 pm
 *
 * Copyright (c) 2020-2021 Andrea Corsini T/A RS1 Project - All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 *
 * Modified on Tuesday, 23rd March 2021 2:41:05 pm
 * *****************************************************************************
 */

import Home from './pages/home'
import Privacy from './pages/privacy'
import Terms from './pages/terms'
import Auth from './pages/api/auth'

const routes = [
    { path: '/', component: Home },
    { path: '/privacy-policy', component: Privacy },
    { path: '/termini-servizio', component: Terms },
    { path: '/auth/app', component: Auth },
]

export default routes
